/* START -- PRODUCT RECOMMENDATION */

$(document).ready(function(){
  $(document).on('click','ul.pr_tabs_titles li',function(){
    
      var tab_id = $(this).attr('data-tab');

      $('ul.pr_tabs_titles li').removeClass('current');
      $('.pr_tab_content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
  })
})

/* END -- PRODUCT RECOMMENDATION */

/* START -- FAQ */

$(document).ready(function() {
    $(".new-set > a").on("click", function(e) {
      e.preventDefault();

      const $this = $(this);
      const $content = $this.siblings(".new-content");
      const $icon = $this.find("i");

      // Toggle active class and icons for the clicked accordion item
      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $content.slideUp(200);
        $icon.removeClass("fa-minus").addClass("fa-plus");
      } else {
        $(".new-set > a").removeClass("active").find("i").removeClass("fa-minus").addClass("fa-plus");
        $(".new-content").slideUp(200);

        $this.addClass("active");
        $content.slideDown(200);
        $icon.removeClass("fa-plus").addClass("fa-minus");
      }
    });
  });

/* END -- FAQ */

/* START -- LOGO MARQUEE */

$('.logo_marquee_slider').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

/* END -- LOGO MARQUEE */


/* START -- CUSTOMER REVIEWS */

$('.customer_review_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 0,
  dots: true,
  arrows: true,
  prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M17.9059 9.99272C17.9059 10.4284 17.6045 10.7463 17.1691 10.7463L6.14518 10.7463L4.36232 10.6792L7.10768 13.182L8.98268 15.0906C9.11661 15.2245 9.18375 15.4252 9.18375 15.6177C9.18375 16.0363 8.86589 16.3463 8.45518 16.3463C8.25447 16.3463 8.07875 16.2706 7.91125 16.1117L2.34482 10.5542C2.17768 10.3949 2.09375 10.2024 2.09375 9.99344C2.09375 9.79237 2.17768 9.59987 2.34482 9.44058L7.91125 3.88272C8.07911 3.72379 8.25446 3.64844 8.45554 3.64844C8.86554 3.64844 9.18375 3.95808 9.18375 4.36808C9.18375 4.56915 9.11661 4.76987 8.98268 4.90379L7.10768 6.80379L4.35411 9.31522L6.14518 9.24808L17.1691 9.24808C17.6045 9.24808 17.9059 9.55737 17.9059 9.99272Z" fill="black"/></path></svg></button>',
  nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2.09411 9.99272C2.09411 10.4284 2.39553 10.7463 2.83089 10.7463L13.8548 10.7463L15.6377 10.6792L12.8923 13.182L11.0173 15.0906C10.8834 15.2245 10.8162 15.4252 10.8162 15.6177C10.8162 16.0363 11.1341 16.3463 11.5448 16.3463C11.7455 16.3463 11.9212 16.2706 12.0887 16.1117L17.6552 10.5542C17.8223 10.3949 17.9062 10.2024 17.9062 9.99344C17.9062 9.79237 17.8223 9.59987 17.6552 9.44058L12.0887 3.88272C11.9209 3.72379 11.7455 3.64844 11.5445 3.64844C11.1345 3.64844 10.8162 3.95808 10.8162 4.36808C10.8162 4.56915 10.8834 4.76987 11.0173 4.90379L12.8923 6.80379L15.6459 9.31522L13.8548 9.24808L2.83089 9.24808C2.39553 9.24808 2.09411 9.55737 2.09411 9.99272Z" fill="black"/></path></svg></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

/* END -- CUSTOMER REVIEWS */

/* START -- PRODUCT DESCRIPTION TAB */

jQuery(document).ready(function() {
  // accordian
  jQuery(".tab-collapse .tab-heading").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
        .siblings(".tab-content")
        .slideUp(200);
      jQuery(".tab-collapse .tab-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
     jQuery(".tab-collapse .tab-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      jQuery(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      jQuery(".tab-collapse .tab-heading").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".tab-content").slideUp(200);
      jQuery(this)
        .siblings(".tab-content")
        .slideDown(200);
    }
  });
});

/* END -- PRODUCT DESCRIPTION TAB */

jQuery(".complete-product_variant_selector").on("change", function() {
  var selVal = $(this).val();
  var pid = $(this).attr('data-pid');
  var vimg = $('option:selected', this).attr('data-img');
  $('#complete_id_'+pid).val(selVal);
  $('.cover_img_'+pid).attr('src', vimg);
});

jQuery(".complete-product-btn-cart").on("click", function() {
  var pid = $(this).attr('data-pid');
  $('#ProductSubmitButton-'+pid).trigger('click');
  setTimeout(function(){
    $('[product--id="' + pid + '"]').hide();
  }, 1500);
});

jQuery(".sticky_product_selector").on("change", function() {
  var selVal = $(this).val();
  var pid = $(this).attr('data-pid');
  $('#sticky__id_'+pid).val(selVal);
});
jQuery(".ps_product_atclink").on("click", function() {
  var pid = $(this).attr('data-pid');
  $('#ProductStickySubmitButton-'+pid).trigger('click');
});


/* START -- PRODUCT SIZE CHART POPUP */

jQuery(document).ready(function(){
  jQuery(".pill-sizeguide").on("click",function () {
    $(".sizemodal").show();
    $("body").addClass("product_sizechart_active");
  });
  jQuery(".sizemodal-close").on("click",function () {
    $(".sizemodal").hide();
    $("body").removeClass("product_sizechart_active");
  });
});

/* START -- PRODUCT SIZE CHART POPUP */


/* START -- PRODUCT STICKY BAR */

if(jQuery('.product_buy_buttons').length!=0){
  jQuery(window).scroll(function(){
    var buttonHeight = parseInt(jQuery('.product_buy_buttons').offset().top);
    // var compareSectionTop = parseInt(jQuery('.comparison-chart-section').offset().top);
    if (jQuery(this).scrollTop() > buttonHeight && jQuery(this).scrollTop()) {
        jQuery('.product_sticky_bar').show();
    }else{
        jQuery('.product_sticky_bar').hide();
    }
  });
}

/* END -- PRODUCT STICKY BAR */

/* START -- PRODUCT SWATCH NAME START */
jQuery(document).ready(function(){
  var getShirtColor = jQuery('.farbe-options:checked').val();
  jQuery('.variant_form_label_box').eq(0).find('b').text(getShirtColor);

  var getSize = jQuery('.swatch-options:checked').val();
  jQuery('.variant_form_label_box').eq(1).find('b').text(getSize);
});

jQuery(document).on("change",".farbe-options",function(){
  var getShirtColor = jQuery(this).val();
  jQuery('.variant_form_label_box').eq(0).find('b').text(getShirtColor);
});
jQuery(document).on("click",".swatch-options",function(){
  var getSize = jQuery(this).val();
  jQuery('.variant_form_label_box').eq(1).find('b').text(getSize);
});
/* END -- PRODUCT SWATCH NAME START */


//:: START :: Product galery  :: ==================

$(".product---gallery-v1").find(".product__gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product__thumbnail",
    arrows: true,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21.4873 11.995C21.4873 12.5178 21.1256 12.8993 20.6031 12.8993L7.37443 12.8993L5.235 12.8187L8.52943 15.8221L10.7794 18.1124C10.9401 18.2731 11.0207 18.514 11.0207 18.745C11.0207 19.2473 10.6393 19.6193 10.1464 19.6193C9.90557 19.6193 9.69471 19.5284 9.49371 19.3377L2.814 12.6687C2.61343 12.4775 2.51271 12.2465 2.51271 11.9958C2.51271 11.7545 2.61343 11.5235 2.814 11.3324L9.49371 4.66298C9.69514 4.47226 9.90557 4.38184 10.1469 4.38184C10.6389 4.38184 11.0207 4.75341 11.0207 5.24541C11.0207 5.48669 10.9401 5.72755 10.7794 5.88826L8.52943 8.16826L5.22514 11.182L7.37443 11.1014L20.6031 11.1014C21.1256 11.1014 21.4873 11.4725 21.4873 11.995Z" fill="black"/></path></svg></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M2.51272 11.995C2.51272 12.5178 2.87443 12.8993 3.39686 12.8993L16.6256 12.8993L18.765 12.8187L15.4706 15.8221L13.2206 18.1124C13.0599 18.2731 12.9793 18.514 12.9793 18.745C12.9793 19.2473 13.3607 19.6193 13.8536 19.6193C14.0944 19.6193 14.3053 19.5284 14.5063 19.3377L21.186 12.6687C21.3866 12.4775 21.4873 12.2465 21.4873 11.9958C21.4873 11.7545 21.3866 11.5235 21.186 11.3324L14.5063 4.66298C14.3049 4.47226 14.0944 4.38184 13.8531 4.38184C13.3611 4.38184 12.9793 4.75341 12.9793 5.24541C12.9793 5.48669 13.0599 5.72755 13.2206 5.88826L15.4706 8.16826L18.7749 11.182L16.6256 11.1014L3.39686 11.1014C2.87443 11.1014 2.51272 11.4725 2.51272 11.995Z" fill="black"/></path></svg></button>',
    dots: false,
    draggable: false,
    focusOnSelect: false,
});
$(".product---gallery-v1").find(".product__thumbnail").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product__gallery",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    speed: 200,
    infinite: false,
    arrows: true,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 521,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
});
jQuery(document).on("click",".zoom-gallery",function(){
  jQuery('body').addClass("product-popup-open");
  jQuery('.product-media-modal').attr('open','');
});
jQuery(document).on("click",".product-media-modal__toggle",function(){
  jQuery('body').removeClass("product-popup-open");
});
jQuery(document).on("click",".hchoose-modal-button",function(){  
  jQuery('.hchoose-modal').addClass('js-modal-open');
});
jQuery(document).on('click',".hchoose-close",function(){
   jQuery('.hchoose-modal').removeClass('js-modal-open');
});
//:: END :: Product galery  :: ==================